import React, { useEffect, useRef, useState, type Dispatch, type SetStateAction } from 'react';
import { IonDatetime, IonIcon, IonModal } from '@ionic/react';
import './style.css';
import { formatDateForInput } from '../../tools/TimeRelated';
import { TimePicker } from '@mui/x-date-pickers';
import dayjs, { type Dayjs } from 'dayjs';
import { refreshCircleOutline } from 'ionicons/icons';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  date: number;
  setDate: Dispatch<SetStateAction<number>>;
  setIsEditedDate?: Dispatch<SetStateAction<boolean>>;
}

const MuiCalendar: React.FC<ModalProps> = ({ isOpen, onClose, date, setDate, setIsEditedDate }) => {
  const [selectedDate, setSelectedDate] = useState<string>(formatDateForInput(date));
  const [selectedTime, setSelelectTime] = useState<Dayjs | null>(dayjs());
  const modal = useRef<HTMLIonModalElement>(null);

  const handleDateChange = (e: CustomEvent) => {
    setSelectedDate(e.detail.value);
  };

  const handleConfirm = () => {
    if (selectedTime === null) return;
    const confirmedDate = new Date(selectedDate);
    confirmedDate.setHours(selectedTime.hour());
    confirmedDate.setMinutes(selectedTime.minute());
    confirmedDate.setSeconds(selectedTime.second());
    console.log(confirmedDate);
    setDate(confirmedDate.getTime());
    if (setIsEditedDate != null) setIsEditedDate(true);
    onClose();
  };

  useEffect(() => {
    console.log(selectedTime);
  }, [selectedTime])

  return (
    <IonModal
      ref={modal}
      isOpen={isOpen}
      focusTrap={false}
      onDidDismiss={() => {
        onClose();
      }}
      id="style1-modal"
    >
      <div className="p-3 bg-white">
        <div>Modal
          <IonDatetime presentation='date' value={selectedDate} onIonChange={handleDateChange} locale="fr-FR" color="rose" />
          <div className='flex flex-row justify-end items-center'>
            <TimePicker className="w-32 float-right" value={selectedTime} onClose={() => { void modal.current?.dismiss(); handleConfirm(); }} onChange={(newTime) => { setSelelectTime(newTime); }} closeOnSelect={false} />
            <IonIcon icon={refreshCircleOutline} className='w-8 h-8 pr-2' onClick={(e) => {
              setSelectedDate(formatDateForInput(Date.now()));
              setSelelectTime(dayjs());
            }}></IonIcon>
            {/* <IonDatetime value={selectedDate} onIonChange={handleDateChange} locale="fr-FR" color="rose" /> */}
            <div className="flex justify-end">
              <button className="border-none outline-none bg-ionic-primary text-ionic-light p-2 rounded-xl font-semibold" onClick={() => { void modal.current?.dismiss(); handleConfirm(); }}>
                Confirmer
              </button>
            </div>
          </div>
        </div>
      </div>
    </IonModal>
  );
};

export default MuiCalendar;
